import Flux from 'lib/flux';

const SearchConstants = Flux.createConstants({
  serviceMessages: [
    'UPDATE_AVAILABILITY_DATES',
    'UPDATE_AVAILABILITY_PEOPLE',
    'UPDATE_CATEGORIES',
    'FILTER',
    'SEARCH',
    'CHANGE_PAGE',
    'SORT_BY',
    'INQUIRE',
    'APPEND_PAGE',
  ],
});

export default SearchConstants;
